import { useEffect } from 'react'

/**
 * Freezes the page behind a modal.
 *
 * `overflow: hidden` on <body> is not enough on iOS Safari - it keeps scrolling
 * the page underneath, which is what made the calendar move instead of the slot
 * sheet. Pinning the body with `position: fixed` at its current offset is the
 * only thing that reliably holds, and the offset has to be restored on close or
 * the page jumps to the top.
 */
export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return

    const { body } = document
    const y = window.scrollY
    const previous = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow,
    }

    body.style.position = 'fixed'
    body.style.top = `-${y}px`
    body.style.left = '0'
    body.style.right = '0'
    body.style.width = '100%'
    body.style.overflow = 'hidden'

    return () => {
      Object.assign(body.style, previous)
      window.scrollTo(0, y)
    }
  }, [active])
}
